import React from "react";

interface TableProps {
  children: React.ReactNode;
}

const Table = ({ children }: TableProps) => {
  return (
    <div className="overflow-x-auto py-4 mx-2 md:mx-10 w-full min-w-0">
      <table className="text-center font-sans w-auto mx-auto">{children}</table>
    </div>
  );
};

export default Table;
